import React from 'react';
import { FIRST_CLAUSE, newClause, TERM_SAMPLES } from './terms';

/**
 * Clause-by-clause editor for the extra terms. Plain text only; numbering
 * (ข้อ 9, 10 …) is automatic.
 */
const TermsEditor = ({ items, onChange, locked }) => {
  const update = (index, patch) => onChange(items.map((it, i) => (i === index ? { ...it, ...patch } : it)));
  const remove = (index) => onChange(items.filter((_, i) => i !== index));
  const move = (index, delta) => {
    const next = [...items];
    const target = index + delta;
    if (target < 0 || target >= next.length) return;
    [next[index], next[target]] = [next[target], next[index]];
    onChange(next);
  };
  const add = (clause = newClause()) => onChange([...items, clause]);

  return (
    <div className="rs-terms">
      {items.length === 0 && (
        <div className="rs-terms__empty">ยังไม่มีข้อตกลงเพิ่มเติม — ไม่บังคับ เพิ่มเมื่อมีเงื่อนไขนอกเหนือจากแบบสัญญามาตรฐาน</div>
      )}

      {items.map((item, i) => (
        <div className="rs-terms__clause" key={i}>
          <div className="rs-terms__head">
            <span className="rs-terms__no">ข้อ {FIRST_CLAUSE + i}</span>
            <input
              type="text"
              className="rs-input"
              placeholder="หัวข้อ เช่น เงินมัดจำ"
              value={item.title}
              disabled={locked}
              maxLength={120}
              onChange={(e) => update(i, { title: e.target.value })}
            />
            <div className="rs-terms__tools">
              <button type="button" className="econ-icon-btn" disabled={locked || i === 0} onClick={() => move(i, -1)} title="เลื่อนขึ้น"><i className="bi bi-arrow-up"></i></button>
              <button type="button" className="econ-icon-btn" disabled={locked || i === items.length - 1} onClick={() => move(i, 1)} title="เลื่อนลง"><i className="bi bi-arrow-down"></i></button>
              <button type="button" className="econ-icon-btn econ-icon-btn--danger" disabled={locked} onClick={() => remove(i)} title="ลบข้อนี้"><i className="bi bi-trash"></i></button>
            </div>
          </div>
          <textarea
            className="rs-input"
            rows={4}
            placeholder="พิมพ์เนื้อหาตามปกติ — ขึ้นบรรทัดใหม่เพื่อแยกเป็นข้อย่อย (ระบบใส่เลข 9.1, 9.2 ให้เอง)"
            value={item.body}
            disabled={locked}
            onChange={(e) => update(i, { body: e.target.value })}
          />
          {/_{3,}/.test(`${item.title} ${item.body}`) && (
            <div className="rs-help rs-help--warn"><i className="bi bi-exclamation-circle"></i> มีช่องว่าง ___ ที่ต้องกรอกตัวเลขก่อนส่ง</div>
          )}
        </div>
      ))}

      <div className="rs-terms__add">
        <button type="button" className="rs-btn rs-btn--ghost rs-btn--sm" disabled={locked} onClick={() => add()}>
          <i className="bi bi-plus-lg"></i> เพิ่มข้อตกลง
        </button>
        <span className="rs-terms__samples-label">หรือเริ่มจากตัวอย่าง:</span>
        {TERM_SAMPLES.map(sample => (
          <button type="button" key={sample.label} className="rs-chipbtn" disabled={locked}
            onClick={() => add(newClause({ title: sample.title, body: sample.body }))}>
            + {sample.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TermsEditor;
